var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 50,
    height: 32,
    rx: 3,
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M22.4666 21.5355H19.3884L21.3137 10.5H24.3918L22.4666 21.5355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M33.6256 10.7699C33.0184 10.5466 32.0554 10.3 30.8647 10.3C27.8248 10.3 25.6841 11.8027 25.671 13.951C25.6457 15.536 27.2036 16.4164 28.3688 16.9448C29.5598 17.4849 29.9646 17.8374 29.9646 18.3187C29.9525 19.058 29.0022 19.3988 28.116 19.3988C26.887 19.3988 26.2285 19.2231 25.2278 18.8118L24.8224 18.6355L24.3917 21.1127C25.1136 21.4176 26.4438 21.6882 27.8248 21.7C31.0547 21.7 33.1575 20.2207 33.1824 17.9313C33.1947 16.6751 32.3721 15.7125 30.5985 14.9259C29.5219 14.421 28.8625 14.0805 28.8625 13.5639C28.8752 13.0942 29.4202 12.6131 30.6356 12.6131C31.6363 12.5896 32.3716 12.8125 32.9286 13.0357L33.207 13.1529L33.6256 10.7699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M37.7169 17.626C37.9704 16.992 38.9458 14.5384 38.9458 14.5384C38.9331 14.5619 39.1989 13.8927 39.3509 13.4819L39.566 14.4327C39.566 14.4327 40.1489 17.0743 40.2755 17.626C39.7944 17.626 38.3249 17.626 37.7169 17.626ZM41.5166 10.5H39.1356C38.4013 10.5 37.8435 10.6994 37.5267 11.4156L32.9543 21.5353H36.1842C36.1842 21.5353 36.716 20.1733 36.8303 19.88C37.1846 19.88 40.3267 19.88 40.7825 19.88C40.8709 20.2674 41.1498 21.5353 41.1498 21.5353H44L41.5166 10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M16.8173 10.5L13.8026 18.0252L13.4732 16.499C12.9158 14.7379 11.1679 12.8246 9.21729 11.8733L11.9786 21.5238H15.2338L20.0723 10.5H16.8173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M11.0033 10.5H6.05067L6 10.723C9.86336 11.6388 12.422 13.8462 13.4732 16.4994L12.3966 11.4276C12.2193 10.7228 11.6746 10.5232 11.0033 10.5Z",
    fill: "#FAA61A"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.305aa26c0374c826ce458ea1d5c18aaf.svg";
export { ForwardRef as ReactComponent };